<template>
  <div>
    <div class="row">
      <div v-for="(data, id) in datas" :key="id" class="col-6 d-flex">
        <div class="card card_grey flex-fill mb-0">
          <div class="sub_title_2">
            {{ data.metricName }} ({{ data.currency }})
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <div class="data_text">
                {{ convertCurrency(data.value) }} {{ data.unit }}
              </div>
              <div class="d-flex mt-2">
                <div
                  class="d-inline-flex align-items-center"
                  :class="
                    data.achievementStatus == 'UP' ? 'badge_green' : 'badge_red'
                  "
                >
                  <IconSvg
                    :color="data.achievementStatus == 'UP' ? 'green' : 'red'"
                    :type="
                      data.achievementStatus == 'UP' ? 'chart_up' : 'chart_down'
                    "
                  />
                  <div
                    class="data_detil"
                    :class="
                      data.achievementStatus == 'UP' ? 'text_green' : 'text_red'
                    "
                  >
                    {{ data.achievement }}
                  </div>
                </div>
                <div
                  class="d-inline-flex align-items-center me-2"
                  :class="
                    data.trendStatus == 'UP' ? 'badge_green' : 'badge_red'
                  "
                >
                  <IconSvg
                    :color="data.trendStatus == 'UP' ? 'green' : 'red'"
                    :type="data.trendStatus == 'UP' ? 'arrow_up' : 'arrow_down'"
                  />
                  <div
                    class="data_detil"
                    :class="
                      data.trendStatus == 'UP' ? 'text_green' : 'text_red'
                    "
                  >
                    {{ data.trend }}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <button class="naked_button" @click="onShowModalPersonnel()">
                <img src="@/assets/images/a/chart_icon.svg" />
              </button>
            </div>
          </div>
          <div class="data_revenue">{{ data.personnel_value }}% of Revenue</div>
        </div>
      </div>
      <!-- <div class="col-6 d-flex">
        <div class="card card_grey flex-fill mb-0">
          <div class="sub_title_2">{{ data.pension_name }} (IDR)</div>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <div class="data_text">{{ convertCurrency(data.pension_value) }} Tn</div>
              <div class="d-flex mt-2">
                <div class="d-inline-flex align-items-center me-2 "
                  :class="data.pension_trend_status == 'UP' ? 'badge_green' : 'badge_red'">
                  <IconSvg :color="data.pension_trend_status == 'UP' ? 'green' : 'red'"
                    :type="data.pension_trend_status == 'UP' ? 'arrow_up' : 'arrow_down'" />
                  <div class="data_detil" :class="data.pension_trend_status == 'UP' ? 'text_green' : 'text_red'">
                    {{ data.pension_trend }}
                  </div>
                </div>
                <div class="d-inline-flex align-items-center "
                  :class="data.pension_achievement_status == 'UP' ? 'badge_green' : 'badge_red'">
                  <IconSvg :color="data.pension_achievement_status == 'UP' ? 'green' : 'red'"
                    :type="data.pension_achievement_status == 'UP' ? 'chart_up' : 'chart_down'" />
                  <div class="data_detil" :class="data.pension_achievement_status == 'UP' ? 'text_green' : 'text_red'">
                    {{ data.pension_achievement }}
                  </div>
                </div>
              </div>
            </div>
            <div>
            </div>
          </div>
          <div class="data_revenue">{{ data.pension_value }}% of Revenue</div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import LegalService from "@/services/legal/legal";
import { currencyFormatNumberComma } from "@/utils/helper";

const apiLegal = LegalService.build();

export default {
  props: ["load", "datas"],
  components: {
    IconSvg,
  },

  data() {
    return {
      modalPersonnel: {
        show: false,
        load: false,
      },
    };
  },

  methods: {
    convertCurrency(x) {
      const str = x.toString();
      if (str.includes(".")) {
        const cnv = str.split(".")[0];
        let dotIndex = str.indexOf(".");
        const after = str.slice(dotIndex + 1);
        return currencyFormatNumberComma(cnv) + "." + after;
      } else {
        return currencyFormatNumberComma(str);
      }
    },
    onShowModalPersonnel() {
      this.modalPersonnel.show = true;
    },
    onCloseModalPersonnel(value) {
      this.modalPersonnel.show = value;
    },
  },
};
</script>
